export default __webpack_public_path__ + "static/media/videotron.12ded776.png";